import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["delay", "id", "style", "text", "theme"];

var _templateObject, _templateObject2, _templateObject3;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import React from 'react';
import { THEMES } from "../../utilities";
import PropTypes from 'prop-types';
import { animated, useSpring } from 'react-spring/web.cjs';
import styled, { css } from 'styled-components';
import { getHexToRgb, getRem, transitionAnimation, typographyCaption, wordBreak } from "./../../core";
import { jsx as _jsx } from "react/jsx-runtime";

var getTooltipThemeCss = function getTooltipThemeCss(theme, tooltipTheme) {
  switch (tooltipTheme) {
    case THEMES.DARK:
    case THEMES.PRIMARY:
      return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        background-color: rgba(", ");\n        color: ", ";\n      "])), getHexToRgb(theme.color.additional.light.value, 0.9), theme.color.additional.dark.value);

    case THEMES.LIGHT:
    default:
      return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        background-color: ", ";\n        color: ", ";\n      "])), theme.color.additional.dark.value, theme.color.additional.light.value);
  }
};

var StyledAnimatedTooltip = styled(animated.span).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['tooltipTheme'].includes(prop);
  }
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n  ", "\n  ", "\n    border-radius: ", ";\n  box-sizing: border-box;\n  display: inline-flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  margin: 0;\n  max-width: ", ";\n  padding: ", " ", ";\n  position: fixed;\n  top: 0;\n  user-select: none;\n  z-index: ", ";\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return typographyCaption(theme);
}, transitionAnimation('opacity'), wordBreak, function (_ref2) {
  var theme = _ref2.theme;
  return theme.size.borderRadius.large.value;
}, getRem('192px'), function (_ref3) {
  var theme = _ref3.theme;
  return theme.size.spacing.medium.value;
}, getRem('12px'), function (_ref4) {
  var theme = _ref4.theme;
  return theme.zIndex.tooltip.value;
}, function (_ref5) {
  var theme = _ref5.theme,
      tooltipTheme = _ref5.tooltipTheme;
  return getTooltipThemeCss(theme, tooltipTheme);
});
var Tooltip = /*#__PURE__*/React.forwardRef(function (_ref6, ref) {
  var delay = _ref6.delay,
      id = _ref6.id,
      style = _ref6.style,
      text = _ref6.text,
      theme = _ref6.theme,
      other = _objectWithoutProperties(_ref6, _excluded);

  var animationProps = useSpring({
    config: {
      duration: 200
    },
    delay: delay,
    from: {
      opacity: 0
    },
    opacity: 1
  });
  return /*#__PURE__*/_jsx(StyledAnimatedTooltip, _objectSpread(_objectSpread({
    id: id,
    ref: ref,
    role: "tooltip",
    style: _objectSpread(_objectSpread({}, animationProps), style),
    tooltipTheme: theme
  }, other), {}, {
    children: text
  }));
});
Tooltip.propTypes = {
  /** Delay in ms before tooltip appears on hover */
  delay: PropTypes.number,

  /** Unique identifier of the component */
  id: PropTypes.string.isRequired,

  /** Inline styles applied to main component wrapper */
  style: PropTypes.shape({}),

  /** Component content */
  text: PropTypes.node.isRequired,

  /** Changes style depending on theme */
  theme: PropTypes.oneOf(Object.values(THEMES))
};
Tooltip.defaultProps = {
  delay: 500,
  style: {},
  theme: THEMES.LIGHT
};
export { Tooltip };